//GeneratorFlag:[NoChange]
import LetterPattern from './letter-pattern';

export default {LetterPattern}
export{LetterPattern}